<template>
  <button class="filter__button" :id="id" @click="$emit('toggleFilter')">
    <div v-if="active" class="filter__button--active" />
    <font-awesome-icon :icon="['fal', 'filter']" />
  </button>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFilter } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faFilter);

export default {
  name: "FilterButton.vue",
  components: { FontAwesomeIcon },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";

.filter__button {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  margin-left: 8px;
  outline: 0;
  background: $grey_alabaster;
  border: 1px solid $grey_alabaster;
  border-radius: 6px;
  height: 44px;
  font-size: 16px;

  &:hover {
    cursor: pointer;
  }
}
.filter__button--active {
  display: inline-block;
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  background-color: $blue;
  border-radius: 4px;
}
</style>
